import { FilterState } from '@hooks/useItemsFilters'

export const setSearchValue =
  (value: string, key = 'search') =>
  (prev: FilterState): FilterState => {
    return {
      ...prev,
      [key]: value,
    }
  }
